// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1GQLN","label":"SetPasswdForm_label__3OOVZ"};